import React, { useCallback } from 'react';
import { Link, LinkButton, Typography } from '@vtblife/uikit';
import classname from '@search/classname/src';
import { abbreviateNumber } from '@search/helpers/src/formatNumber';
import './styles.css';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';
import { useClassifiedOfferDataLayerPush } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import Image from '../../../Image';
import { LandMortgageActionType } from '../constants';
import EmptyMortgageOffer from '../images/icons/EmptyMortgageOffer.url.svg';
import VTB from '../images/icons/VTB.url.svg';

const cn = classname.bind(null, 'MortgageOffer');

export const MortgageOffer = ({
    creditSum,
    isEmpty = false,
    imgSrc,
    isMobile = false,
    modalHandler
}: {
    creditSum: number;
    isEmpty: boolean;
    imgSrc: string;
    isMobile: boolean;
    modalHandler: () => void;
}) => {
    const staticPath = useStaticPathConfig();
    const dataLayerPush = useClassifiedOfferDataLayerPush();

    const handleLearnMore = useCallback(() => {
        dataLayerPush({
            event: 'up_action',
            theme: 'ipoteka',
            page_type: 'card',
            type: LandMortgageActionType.IzhsLearnMore
        });
    }, [ dataLayerPush ]);

    return (
        <div className={cn()}>
            {
                isEmpty ?
                    <div className={cn('empty-offer')}>
                        <Image url={`${staticPath}${EmptyMortgageOffer}`} loading='lazy' alt='нет предложений' />
                        <Typography>Попробуйте выбрать участок дешевле или увеличить платёж в месяц</Typography>
                    </div> :
                    <div className={cn('offer')}>
                        <div className={cn('price-section')}>
                            <div>
                                <Typography className={cn('value-text')} variant='h4'>до {abbreviateNumber(creditSum).value} {abbreviateNumber(creditSum).type} ₽</Typography>
                                <Typography variant='secondary-alone' color='secondary'>сумма кредита</Typography>
                            </div>
                            <div>
                                <Typography variant='h4' className={cn('value-text')}>от 20%</Typography>
                                <Typography variant='secondary-alone' color='secondary'>{isMobile ? 'первый' : 'первоначальный'} взнос</Typography>
                            </div>
                        </div>
                        <div className={cn('bank-section')}>
                            <div className={cn('bank')}>
                                <Image url={`${staticPath}${VTB}`} loading='lazy' alt='ВТБ' />
                                <div>
                                    <Typography>ВТБ банк</Typography>
                                    <Typography variant='secondary-alone' color='secondary'>Льготные прогаммы</Typography>
                                    <Typography variant='secondary-alone' className={cn('rate')}>ставка от 6,6%</Typography>
                                </div>
                            </div>
                            <div className={cn('image')}>
                                { imgSrc && <Image url={`${imgSrc}`} loading='lazy' alt='дом' />}
                            </div>
                        </div>
                    </div>
            }

            {
                isMobile &&
                <div className={cn('bottom-section')}>
                    { isEmpty && <Link href='https://m2.ru/ipoteka/stroitelstvo-doma/' target='blank' onClick={handleLearnMore}>Узнать о программе больше&nbsp;➔</Link> }
                    <LinkButton
                        variant='accent'
                        disabled={isEmpty}
                        fullWidth
                        onClick={modalHandler}
                        size='m'
                    >
                        Получить подробный расчёт
                    </LinkButton>
                    { ! isEmpty &&
                        <div className={cn('mobile-link')}>
                            <Link
                                href='https://m2.ru/ipoteka/stroitelstvo-doma/'
                                target='blank'
                                onClick={handleLearnMore}
                            >
                                Узнать больше о программе
                            </Link>
                        </div>
                    }
                </div>
            }
        </div>
    );
};
